<template>
  <div>
    <div class="my-licence">
      <div class="account-card">
        <div class="account-card-header">
          <h4 class="account-card-title">公告审批设置</h4>
        </div>
      </div>
    </div>
    <!-- <el-divider></el-divider> -->
    <div class="content">
      <el-form
        :model="list"
        ref="ruleForm"
        :rules="FormRules"
        class="contentform"
        label-width="140px"
      >
        <el-form-item label="处置公告审批层级:" prop="list">
          <el-select v-model="value" placeholder="请选择" @change="select">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div style="height: 200px" v-if="!flag"></div>
      <el-table border :data="tableData" style="width: 100%" v-if="flag">
        <el-table-column prop="date" label="审批层级" width="180">
        </el-table-column>
        <el-table-column label="审批用户">
          <template slot-scope="scope">
            <span v-for="(item, index) in scope.row.name" :key="index"
              >{{ item.name }}
            </span></template
          >
        </el-table-column>
        <el-table-column prop="address" label="操作" width="180">
          <template slot-scope="scope">
            <span class="dianaji" @click="setUser(scope)">设置用户</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="primary">
        <el-row :gutter="20">
          <el-col :span="6" :offset="9">
            <el-button type="primary" @click="Submit()">提交</el-button></el-col
          >
        </el-row>
      </div>
      <el-dialog title="设置审批用户" :visible.sync="dialogTableVisible">
        <el-form ref="form" :model="form" label-width="130px">
          <el-form-item label="公告审批层级:">
            <span>{{ dialogtilt }}</span>
          </el-form-item>
          <el-form-item label="审批用户:">
            <el-checkbox-group v-model="form.type">
              <span v-for="item in formdialog" :key="item.id" class="span">
                <el-checkbox
                  :label="item.id"
                  :title="item.userName"
                  name="type"
                  >{{ item.name }}</el-checkbox
                >
              </span>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      flag: true,
      options: [
        {
          value: '1',
          label: '一级'
        },
        {
          value: '2',
          label: '二级'
        },
        {
          value: '3',
          label: '三级'
        },
        {
          value: '4',
          label: '四级'
        },
        {
          value: '5',
          label: '五级'
        },
        {
          value: '0',
          label: '无需审核'
        }
      ],
      value: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      series: null,
      dialogtiltNam: null,
      formdialog: [],
      checkList: [],
      dialogtilt: '',
      tableData: [
        {
          date: '一级',
          name: ''
        },
        {
          date: '二级',
          name: ''
        },
        {
          date: '三级',
          name: ''
        },
        {
          date: '四级',
          name: ''
        },
        {
          date: '五级',
          name: ''
        }
      ],
      gridData: [],
      dialogTableVisible: false,
      list: {},
      radio: '1',
      FormRules: {
        list: [{ required: true, message: ' ', trigger: 'blur' }]
      },
      original: {}
    }
  },
  created() {
    this.users()
    this.sellerAuditGet()
  },

  methods: {
    async sellerAuditGet() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      let data = await this.$api.materialdisposal.sellerAuditGet()
      loading.close()

      this.series = data.auditLevel
      if (data) {
        if (data.auditLevel === 1) {
          this.value = '一级'
          this.tableData = [
            {
              date: '一级',
              name: []
            }
          ]

          this.tableData[0].name = data.auditer1
        }
        if (data.auditLevel === 2) {
          this.value = '二级'
          this.tableData = [
            {
              date: '一级',
              name: []
            },
            {
              date: '二级',
              name: []
            }
          ]

          this.tableData[0].name = data.auditer1
          this.tableData[1].name = data.auditer2
        }
        if (data.auditLevel === 3) {
          this.value = '三级'
          this.tableData = [
            {
              date: '一级',
              name: []
            },
            {
              date: '二级',
              name: []
            },
            {
              date: '三级',
              name: []
            }
          ]
          this.tableData[0].name = data.auditer1
          this.tableData[1].name = data.auditer2
          this.tableData[2].name = data.auditer3
        }
        if (data.auditLevel === 4) {
          this.value = '四级'
          this.tableData = [
            {
              date: '一级',
              name: ''
            },
            {
              date: '二级',
              name: ''
            },
            {
              date: '三级',
              name: ''
            },
            {
              date: '四级',
              name: ''
            }
          ]
          this.tableData[0].name = data.auditer1
          this.tableData[1].name = data.auditer2
          this.tableData[2].name = data.auditer3
          this.tableData[3].name = data.auditer4
        }
        if (data.auditLevel === 5) {
          this.value = '五级'
          this.tableData = [
            {
              date: '一级',
              name: []
            },
            {
              date: '二级',
              name: []
            },
            {
              date: '三级',
              name: []
            },
            {
              date: '四级',
              name: []
            },
            {
              date: '五级',
              name: []
            }
          ]
          this.tableData[0].name = data.auditer1
          this.tableData[1].name = data.auditer2
          this.tableData[2].name = data.auditer3
          this.tableData[3].name = data.auditer4
          this.tableData[4].name = data.auditer5
        }
        if (data.auditLevel === 0) {
          this.value = '无需审核'
          this.flag = false
        }
        if (!data.auditLevel) {
          this.flag = false
        }
      }
    },
    select(o) {
      this.series = o
      if (o == 1) {
        this.tableData = [
          {
            date: '一级',
            name: []
          }
        ]
        this.flag = true
      } else if (o == 2) {
        this.tableData = [
          {
            date: '一级',
            name: []
          },
          {
            date: '二级',
            name: []
          }
        ]
        this.flag = true
      } else if (o == 3) {
        this.tableData = [
          {
            date: '一级',
            name: []
          },
          {
            date: '二级',
            name: []
          },
          {
            date: '三级',
            name: []
          }
        ]
        this.flag = true
      } else if (o == 4) {
        this.tableData = [
          {
            date: '一级',
            name: []
          },
          {
            date: '二级',
            name: []
          },
          {
            date: '三级',
            name: []
          },
          {
            date: '四级',
            name: []
          }
        ]
        this.flag = true
      } else if (o == 5) {
        this.tableData = [
          {
            date: '一级',
            name: []
          },
          {
            date: '二级',
            name: []
          },
          {
            date: '三级',
            name: []
          },
          {
            date: '四级',
            name: []
          },
          {
            date: '五级',
            name: []
          }
        ]
        this.flag = true
      } else {
        this.flag = false
      }
    },
    async users() {
      let data = await this.$api.materialdisposal.users()
      this.formdialog = data
    },
    async Submit() {
      let submit = { auditLevel: Number(this.series) }
      if (this.series == null) {
        this.$message.error('请选择处置公告审批层级')
        return false
      }
      if (submit.auditLevel !== 0) {
        let flag = this.tableData.every(item => {
          return item.name.length !== 0
        })
        if (flag) {
          let auditer1 = []
          let auditer2 = []
          let auditer3 = []
          let auditer4 = []
          let auditer5 = []
          this.tableData.map(item1 => {
            item1.name.map(item2 => {
              if (item1.date === '一级') {
                auditer1.push(item2)
              } else if (item1.date === '二级') {
                auditer2.push(item2)
              } else if (item1.date === '三级') {
                auditer3.push(item2)
              } else if (item1.date === '四级') {
                auditer4.push(item2)
              } else if (item1.date === '五级') {
                auditer5.push(item2)
              }
            })
          })
          let submitobj = {
            ...submit,
            auditer1,
            auditer2,
            auditer3,
            auditer4,
            auditer5
          }

          let data = await this.$api.materialdisposal.save(submitobj)

          if (data) {
            this.$message.success('提交成功')
          }
        } else {
          this.$message.error('每个层级最少选择一个审批用户')
        }
      } else {
        let submitobj = {
          ...submit,
          auditer1: [],
          auditer2: [],
          auditer3: [],
          auditer4: [],
          auditer5: []
        }

        let data = await this.$api.materialdisposal.save(submitobj)

        if (data) {
          this.$message.success('提交成功')
        }
      }
    },
    onSubmit() {
      if (this.form.type && this.form.type.length != 0) {
        this.tableData[this.dialogtiltNam].name = this.formdialog.filter(item =>
          this.form.type.some(obj => obj == item.id)
        )
      }
      this.dialogTableVisible = false
      this.form.type = []
      console.log('submit!')
    },
    setUser(scope) {
      this.form.type = scope.row.name.map(item => {
        return item.id
      })

      this.dialogtiltNam = scope.$index
      if (scope.$index === 0) {
        this.dialogtilt = '一级'
      } else if (scope.$index === 1) {
        this.dialogtilt = '二级'
      } else if (scope.$index === 2) {
        this.dialogtilt = '三级'
      } else if (scope.$index === 3) {
        this.dialogtilt = '四级'
      } else if (scope.$index === 4) {
        this.dialogtilt = '五级'
      }

      this.dialogTableVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
.tilte {
  padding-top: 10px;
}
.content {
  padding-top: 30px;
  padding-left: 50px;
}
.dianaji {
  color: cornflowerblue;
  cursor: pointer;
}
.dialogtilt {
  margin-bottom: 20px;
}
/deep/.el-input__inner {
  width: 200px !important;
}
/deep/.el-input {
  width: 200px !important;
}
.contentform {
  width: 200px;
}
.span {
  margin-right: 5px;
}
.primary {
  margin: 20px;
}
</style>
